





































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Brand} from '@/modules/neovehicle/models';
import {FamilyGroupCreateModel} from '@/modules/neovehicle/models/family';
import {DncClientContract, DncFamilyGroup} from '@/modules/neovehicle/models/dnc';

@Component
export default class extends Vue {
  @Prop({required: true})
  public clients: DncClientContract[];

  @Prop({required: true})
  public isOpen: boolean;

  @Prop()
  public data: DncFamilyGroup | undefined;

  public dncFamilyGroup: DncFamilyGroup = {
    id: 0,
    idclient: 0,
    name: '',
  };

  public isOpenInternal: boolean = false;

  public get isValid() {
    return this.dncFamilyGroup.idclient !== 0
      && this.dncFamilyGroup.name.length !== 0;
  }

  public mounted() {
    this.isOpenInternal = this.isOpen;

    if (this.data) {
      this.dncFamilyGroup = this.data;
    }
  }

  public handleCancel() {
    this.$emit('cancel');
  }

  public handleSave() {
    this.$emit('save', {
      id: this.dncFamilyGroup.id,
      idclient: this.dncFamilyGroup.idclient,
      name: this.dncFamilyGroup.name,
    });
  }
}
